/** Deep-link to collection cases for one customer, keyed by account — not name. */
export function opsCasesPath({ account, caseId, institution } = {}) {
  const params = new URLSearchParams();
  if (account) params.set("account", String(account));
  if (caseId) params.set("caseId", String(caseId));
  if (institution) params.set("institution", String(institution));
  const qs = params.toString();
  return qs ? `/dashboard/cases?${qs}` : "/dashboard/cases";
}

export function caseAccountNumber(row) {
  return String(row?.accountNumber || row?.account_number || "").trim();
}

export function caseMatchesId(row, caseId) {
  const needle = String(caseId || "").trim().toLowerCase();
  if (!needle) return false;
  return (
    String(row?.id || "").toLowerCase() === needle ||
    String(row?.case_id || "").toLowerCase() === needle
  );
}
